export default __webpack_public_path__ + "static/media/Solicitar_Factura.04f9d435.svg";